import { useCallback, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { apiConstants, getGeneric } from '../../../common/constants';

// ABD appointment edit cut-off from the server (fixed rule): { editCutoffTime: 'HH:mm', editCutoffDaysBefore: n }.
export default function useAbdSettings() {
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const load = useCallback(async () => {
        setLoading(true);
        setError(false);
        try {
            const res = await getGeneric(apiConstants.APPOINTMENT_DELIVERY_EDIT_CUTOFF, {});
            setSettings(res?.data || {});
        } catch (e) {
            setError(true);
        }
        setLoading(false);
    }, []);

    useEffect(() => { load(); }, [load]);

    return { settings, loading, error, reload: load };
}

// Edit cut-off for an appointment on `date`. Display only: mirrors the server rule
// (OrderMongoServiceImpl.abdEditCutoff), which re-checks on save. null until the rule is loaded.
export const getEditCutoff = (date, settings) => {
    const time = settings?.editCutoffTime;
    const days = settings?.editCutoffDaysBefore;
    if (!date || !time || days == null) return null;
    const [h, m] = time.split(':').map(Number);
    return dayjs(date).startOf('day').subtract(days, 'day').hour(h).minute(m);
};

// Edit window of the row's active appointment.
export const getEditWindow = (row, settings) => {
    const until = getEditCutoff(row?.appointmentDeliveryData?.appointment_del_start, settings);
    if (!until) return { configured: false, editable: false, until: null };
    return { configured: true, editable: dayjs().isBefore(until), until };
};

// Earliest date an appointment can be moved to: its own cut-off must still be open.
export const getEarliestEditableDate = (settings) => {
    let day = dayjs().add(1, 'day').startOf('day');
    for (let i = 0; i < 31; i++) {
        const cutoff = getEditCutoff(day, settings);
        if (!cutoff || dayjs().isBefore(cutoff)) return day.toDate();
        day = day.add(1, 'day');
    }
    return day.toDate();
};

export const formatCutoff = (until) => (until ? until.format('h:mm A, D MMM YYYY') : '');
